import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppBreadcrumbService } from './app.breadcrumb.service';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import {AppMainComponent} from '../../app.main.component';

@Component({
    standalone: true,
    selector: 'app-breadcrumb',
    templateUrl: './app.breadcrumb.component.html',
    imports: [
        CommonModule,
        BreadcrumbModule
    ]
})
export class AppBreadcrumbComponent implements OnDestroy {

    subscription: Subscription;

    items: MenuItem[];

    home: MenuItem;

    search: string;

    constructor(public breadcrumbService: AppBreadcrumbService, public appMain: AppMainComponent) {
        this.subscription = breadcrumbService.itemsHandler.subscribe(response => {
            this.items = response;
        });

        this.home = { icon: 'fi fi-tr-chart-tree-map', routerLink: '/' };
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
